import {
  RuleBaselineStatusLabelQueryOperationQuery,
  RuleBaselineStatusLabelQueryOperationQueryVariables,
  RuleStatusEnum,
} from '__generated__';
import { delay, graphql, HttpResponse } from 'msw';

export const handlers = [
  graphql.query<
    RuleBaselineStatusLabelQueryOperationQuery,
    RuleBaselineStatusLabelQueryOperationQueryVariables
  >(
    'RuleBaselineStatusLabelQueryOperation',
    async ({ query: _query, variables }) => {
      await delay(1500);
      const { id } = variables;

      return HttpResponse.json({
        data: {
          __typename: 'Query',
          rule: {
            __typename: 'FirstSeenRule',
            id,
            baselineWindowSize: 2592000000,
            baselineLastStarted: '2023-03-25T21:56:08.786772+00:00',
            enabled: true,
            status: {
              __typename: 'RuleStatus',
              status: RuleStatusEnum.Active,
            },
          },
        },
      });
    }
  ),
];
